module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
// module id = 247
// module chunks = 64